import { render, staticRenderFns } from "./AddIncome.vue?vue&type=template&id=66be5c70&scoped=true"
import script from "./AddIncome.vue?vue&type=script&lang=js"
export * from "./AddIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be5c70",
  null
  
)

export default component.exports